import './HomePage.styles.scss';

import React, { useContext, useEffect, useState } from 'react';
import UesrContext from '../../contexts/user-context/UserProvider';
import DocTitleScrollTop from '../../utils/DocTitleScrollTop';
import Axios from 'axios';
import { Facebook } from 'react-content-loader';
import pickSkeletonColor from '../../utils/pickSkeletonColor';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';
import { Avatar, Link, Typography } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import ReactMarkdown from 'react-markdown';
import pickBkgClass from '../../utils/pickBkgClass';
import { ScheduleRounded } from '@material-ui/icons';

const renderNoFollowers = name => (
	<div className="noFollowers">
		<h1>Hello {name}, your feed is empty.</h1>
		<p>
			Your feed displays the latest posts from the people you follow. If you
			don't have any friends to follow that's okay; you can use the "Search"
			feature in the top menu bar to find content written by people with similar
			interests and then follow them.
		</p>
	</div>
);

const HomePage = () => {
	const { user } = useContext(UesrContext);
	const { themeName, themeType } = useContext(MyThemeContext);
	DocTitleScrollTop('Your Feed');

	const [fetchingFeed, setFetchingFeed] = useState(true);
	const [fetchedFeed, setFetchedFeed] = useState([]);
	const sleep = ms => new Promise(r => setTimeout(r, ms));
	useEffect(() => {
		const cancelTokenSource = Axios.CancelToken.source();
		const fetchFeed = async () => {
			await sleep(1000);
			try {
				const response = await Axios.post(
					'/getHomeFeed',
					{
						token: user && user.token
					},
					{
						cancelToken: cancelTokenSource.token
					}
				);
				console.log('Home Feed', response);
				if (response.status === 200 && response.data) {
					setFetchingFeed(false);
					setFetchedFeed(response.data);
				}
			} catch (e) {
				if (Axios.isCancel(e)) {
					console.log('Cought cancel');
				} else {
					throw e;
				}
			}
		};

		fetchFeed();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const renderFetchedFeed = () => {
		return fetchedFeed.map(
			({ _id, title, body, createdDate, author: { username, avatar } }) => (
				<div
					key={_id}
					className={`feedPost ${themeType} ${pickBkgClass(themeName, 'soft')}`}
				>
					<div className="author_date">
						<Avatar src={avatar ? avatar : null} alt="avatar img" />
						<div className="username_date">
							<Link
								className="username"
								component={RouterLink}
								color="primary"
								to={`/profile/${username}`}
							>
								<Typography variant="h6" component="p">
									{username}
								</Typography>
							</Link>
							<Typography className="date" variant="body2">
								<ScheduleRounded />
								{moment(createdDate).fromNow()}
							</Typography>
						</div>
					</div>
					<div className="postContent">
						<Typography className="postTitle" variant="h5" color="inherit">
							{title}
						</Typography>
						<ReactMarkdown
							className="postBody"
							source={body}
							allowedTypes={[
								'paragraph',
								'strong',
								'emphasis',
								'text',
								'heading',
								'list',
								'listItem'
							]}
						/>
					</div>
				</div>
			)
		);
	};

	if (fetchingFeed && fetchedFeed.length === 0) {
		return (
			<div className="myPage homePage">
				<div className="mfaContainer">
					<div className="feedSkeleton">
						<Facebook width="45vw" {...pickSkeletonColor(themeName)} />
						<Facebook width="45vw" {...pickSkeletonColor(themeName)} />
						<Facebook width="45vw" {...pickSkeletonColor(themeName)} />
					</div>
				</div>
			</div>
		);
	} else if (!fetchingFeed && fetchedFeed.length === 0) {
		return (
			<div className="myPage homePage">
				<div className="mfaContainer">{renderNoFollowers(user.username)}</div>
			</div>
		);
	} else if (!fetchingFeed && fetchedFeed.length > 0) {
		return (
			<div className="myPage homePage">
				<div className="mfaContainer">
					<div className="feedsWrapper">{renderFetchedFeed()}</div>
				</div>
			</div>
		);
	}
};

export default HomePage;
